import React from "react";
import PlayerStat from "../PlayerStat";
import {COINS_COLOR, COINS_COLOR_DARK, COINS_COLOR_LIGHT} from "../../../styles/constants";

export function CoinsStat({text, noShrinkOnMobile, className, isDarkColor, isLightColor}) {
  return (
    <PlayerStat
      text={text}
      color={
        isDarkColor ? COINS_COLOR_DARK :
          isLightColor ? COINS_COLOR_LIGHT : COINS_COLOR
      }
      icon={'/img/icons/coins.png'}
      noShrinkOnMobile={noShrinkOnMobile}
      className={`stat-coins ${className || ''}`}
      title={'Монеты'}
    />
  );
}